module.exports = "./assets/assets/相关政策依据.3a486f62.docx";